module.exports = __webpack_public_path__ + "digitalassessments.svg?d3bcd99ef7db83e796b521ca885b5b65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/digitalassessments.svg
// module id = 39
// module chunks = 0